/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accept_ConfirmInputs */

const en_accept_confirm = /** @type {(inputs: Accept_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do you really want to accept this application?`)
};

const de_accept_confirm = /** @type {(inputs: Accept_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbung wirklich annehmen?`)
};

/**
* | output |
* | --- |
* | "Do you really want to accept this application?" |
*
* @param {Accept_ConfirmInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const accept_confirm = /** @type {((inputs?: Accept_ConfirmInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accept_ConfirmInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_accept_confirm(inputs)
	return en_accept_confirm(inputs)
});